<template>
    <ul class="menu-horizontal text-left vue-login" v-show="!loading">
        <li>
            <a href="/app/#/account" class="btn btn--xs type--uppercase btn-my-account" v-show="logged_in"><span class="btn__text">My Account</span></a>
            <notifications position="bottom right" />
            <div class="modal-instance" v-show="!logged_in">
                <a class="btn btn--xs type--uppercase modal-trigger" id="ocLogin" href="#"><span class="btn__text">Login</span></a>
                <div class="modal-container">
                    <div class="modal-content section-modal">
                        <section class="unpad ">
                            <div class="container">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <div class="feature feature-1">
                                            <div class="feature__body boxed boxed--lg boxed--border text-center">
                                                <div class="modal-close modal-close-cross"></div>
                                                <div class="text-block" v-if="!logged_in">
                                                    <h3>Login to your account</h3>
                                                    <p>
                                                        Welcome back, sign in with your existing account credentials.
                                                    </p>
                                                </div>
                                                <div class="text-block" v-if="logged_in">
                                                    <h3>You've successfully logged in</h3>
                                                </div>
                                                <form v-on:submit.prevent class="form container" v-if="!logged_in">
                                                    <div class="row row-pull-out">
                                                        <div class="col-md-12">
                                                            <input type="text" placeholder="Username or Email" v-model="username" @keyup.enter="login" name="email" id="email" autocomplete="email">
                                                            <error-list v-bind:errors="signin_error_results.username"></error-list>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <input type="password" placeholder="Password" v-model="password" @keyup.enter="login" name="password" id="password" autocomplete="password">
                                                            <error-list v-bind:errors="signin_error_results.password"></error-list>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <error-list v-bind:errors="signin_error_results.non_field_errors"></error-list>
                                                            <button class="btn btn--primary type--uppercase" type="submit" v-on:click="login">Login</button>
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <a @click="showForgot = true;" v-if="!showForgot">Forgot your password?</a>
                                                    <div class="text-left" v-if="showForgot">
                                                        <hr />
                                                        <h4>Please enter your email address below to recover your password.</h4>
                                                        <div class="row row-pull-out">
                                                            <div class="col-md-8">
                                                                <input type="email" placeholder="Account Email Address" v-model="passwordRecoveryEmail" />
                                                            </div>
                                                            <div class="col-md-4">
                                                                <button class="btn btn--primary btn-block" @click="recoverPassword">Submit</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!--end of row-->
                                                </form>
                                            </div>
                                        </div>
                                        <!--end feature-->
                                    </div>
                                </div>
                                <!--end of row-->
                            </div>
                            <!--end of container-->
                        </section>
                    </div>
                </div>
            </div>
        </li>
        <li>
            <a class="btn btn--xs type--uppercase" v-show="logged_in" v-on:click="logout"><span class="btn__text">Logout</span></a>
            <div class="modal-instance" v-show="!logged_in">
                <a class="btn btn--xs type--uppercase modal-trigger" href="#"><span class="btn__text">Register</span></a>
                <div class="modal-container">
                    <div class="modal-content">
                        <section class="imageblock feature-large bg--white border--round ">
                            <div class="imageblock__content col-lg-5 col-md-3 pos-left visible-md visible-lg">
                                <div class="background-image-holder">
                                    <img alt="image" src="/public/app-photos/dragonflyhorizontal.jpg" />
                                </div>
                            </div>
                            <div class="container">
                                <div class="row justify-content-end">
                                    <div class="col-lg-7">
                                        <div class="row justify-content-center">
                                            <div class="col-lg-10 col-md-11" v-if="logged_in">
                                                <div class="text-block" v-if="logged_in">
                                                    <h3>Thanks for registering!</h3>
                                                </div>
                                            </div>
                                            <div class="col-lg-10 col-md-11" v-if="!logged_in">
                                                <h2>Create an account</h2>
                                                <p class="lead">Sign up and join the Odonata Central community.</p>
                                                <div class="text-block" v-if="logged_in">
                                                    <h3>You've successfully logged in</h3>
                                                </div>
                                                <div v-if="account_created" class="alert alert-info">
                                                    <strong>Confirm your email address.</strong><br />
                                                    Please continue creating your account by following the instructions in the email we've sent you. <br />If you don't see the confirmation email shortly, please be sure to check your spam folder.
                                                </div>
                                                <div class="form" v-if="!logged_in && !account_created">
                                                    <div class="row">
                                                        <div class="col-12 col-md-6">
                                                            <input type="email" name="Email Address" placeholder="Email Address" v-model="registerEmail" />
                                                            <error-list v-bind:errors="register_error_results.email"></error-list>
                                                        </div>
                                                        <div class="col-12 col-md-6">
                                                            <input type="text" name="Username" placeholder="Username" v-model="registerUsername" />
                                                            <error-list v-bind:errors="register_error_results.username"></error-list>
                                                        </div>
                                                        <div class="col-12 col-md-6">
                                                            <input type="password" name="Password" placeholder="Password" v-model="registerPassword" />
                                                            <error-list v-bind:errors="register_error_results.password"></error-list>
                                                        </div>
                                                        <div class="col-12 col-md-6">
                                                            <input type="password" name="ConfirmPassword" placeholder="Confirm Password" v-model="registerConfirmPassword" />
                                                            <error-list v-bind:errors="register_error_results.re_password"></error-list>
                                                        </div>

                                                        <div class="col-12 col-md-6">
                                                            <input type="text" name="FirstName" placeholder="First Name" v-model="registerFirstName" />
                                                            <error-list v-bind:errors="register_error_results.first_name"></error-list>
                                                        </div>
                                                        <div class="col-12 col-md-6">
                                                            <input type="text" name="LastName" placeholder="Last Name" v-model="registerLastName" />
                                                            <error-list v-bind:errors="register_error_results.last_name"></error-list>
                                                        </div>
                                                        <div class="col-12">
                                                            <strong>Show real name to all users:</strong>
                                                            <div class="input-radio input-radio--innerlabel">
                                                                <input id="registerDirectoryIncludeYes" type="radio" name="registerDirectoryInclude" v-model="registerDirectoryInclude" v-bind:value="true">
                                                                <label for="registerDirectoryIncludeYes">Yes</label>
                                                            </div>
                                                            <div class="input-radio input-radio--innerlabel">
                                                                <input id="registerDirectoryIncludeNo" type="radio" name="registerDirectoryInclude" v-model="registerDirectoryInclude" v-bind:value="false">
                                                                <label for="registerDirectoryIncludeNo">No</label>
                                                            </div>
                                                            <error-list v-bind:errors="register_error_results.include_in_directory"></error-list>
                                                        </div>
                                                        <div class="col-12">
                                                            <error-list v-bind:errors="register_error_results.non_field_errors"></error-list>
                                                            <button type="submit" class="btn btn--primary type--uppercase" v-on:click="register">Create Account</button>
                                                        </div>
                                                        <div class="col-12">
                                                            <span class="type--fine-print">By signing up, you agree to the
                                                                <a href="/terms/" target="_blank">Terms of Service</a>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <!--end row-->
                                                </div>
                                            </div>
                                        </div>
                                        <!--end of row-->
                                    </div>
                                    <!--end of col-->
                                </div>
                                <!--end of row-->
                            </div>
                            <!--end of container-->
                        </section>
                    </div>
                </div>
            </div>
            <div class="modal-instance">
                <div class="modal-container modal-container-needs-username">
                    <div class="modal-content">
                        <section class="imageblock feature-large bg--white border--round ">
                            <div class="imageblock__content col-lg-5 col-md-3 pos-left visible-md visible-lg">
                                <div class="background-image-holder">
                                    <img alt="image" src="/public/app-photos/dragonflyhorizontal.jpg" />
                                </div>
                            </div>
                            <div class="container">
                                <div class="row justify-content-end">
                                    <div class="col-lg-7">
                                        <div class="row justify-content-center">
                                            <div class="col-lg-10 col-md-11">
                                                <h4>Welcome to the new Odonata Central.</h4>
                                                <p>In order to use our new site to it's fullest, please provide a unique username:</p>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <input type="text" name="Username" placeholder="Username" v-model="patchUsername" />
                                                        <error-list v-bind:errors="patch_username_error_results.username"></error-list>
                                                        <error-list v-bind:errors="register_error_results.non_field_errors"></error-list>
                                                        <button type="submit" class="btn btn--primary type--uppercase" v-on:click="updateUsername">Update Username</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--end of row-->
                                    </div>
                                    <!--end of col-->
                                </div>
                                <!--end of row-->
                            </div>
                            <!--end of container-->
                        </section>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
  import global_data from '../../main';
  export default {
    name: 'Login',
    data: function(){
        return {
            patchUsername: "",
            username: "",
            password: "",
            registerEmail: "",
            registerUsername: "",
            registerPassword: "",
            registerConfirmPassword: "",
            registerFirstName: "",
            registerLastName: "",
            registerDirectoryInclude: true,
            signin_error_results: {},
            patch_username_error_results: {},
            register_error_results: {},
            recovery_error_results: {},
            current_user: null,
            loading:true,
            showForgot:false,
            passwordRecoveryEmail:"",
            account_created: false,
        };
    },
    mounted(){
        this.get_user();
    },
    methods:{
        recoverPassword:function(){
            if (!this.passwordRecoveryEmail) {
                this.$notify({
                    text: 'Please enter an email address.',
                    type: 'error',
                });
                return;
            }
            var self = this;
            this.API({
                endpoint: 'auth/users/reset_password',
                funcThen: function(response){
                    self.passwordRecoveryEmail = "";
                    self.showForgot = false;
                    mr.modals.closeActiveModal();
                    self.$notify({
                        text: 'If we found an account we will email you with recovery instructions.',
                        type: 'success',
                    });
                },
                funcCatch: function(error){
                    if (error.response && error.response.data) {
                        self.recovery_error_results = error.response.data;
                    }
                    else{
                        console.log(error);
                    }
                },
                isPost:true,
                postData: { email: self.passwordRecoveryEmail }
            });
        },
        check_username:function(){
            if (this.current_user.username == "user_" + this.current_user.id) {
                mr.modals.showModal($('.modal-container-needs-username'));
            }
        },
        login: function(){
            var self = this;
            this.API({
                endpoint: 'auth/token/login',
                funcThen: function(response){
                    if (response.data.auth_token) {
                        self.$cookie.set('OCAuth', response.data.auth_token, 1);
                        
                        if (self.$router.currentRoute.name == "confirm_account" || self.$router.currentRoute.name == "recover_password") {
                            window.location.href = "/";
                        }
                        else{
                            mr.modals.closeActiveModal();
                            self.$notify({
                                title: 'You\'ve successfully logged in',
                                type: 'success',
                            });
                            self.get_user(true);
                        }
                    }
                },
                funcCatch: function(error){
                    if (error.response && error.response.data) {
                        self.signin_error_results = error.response.data;
                    }
                    else{
                        console.log(error);
                    }
                },
                isPost:true,
                postData: { username: self.username, password: self.password }
            });
        },
        get_user: function(check_username){
            var self = this;
            self.loading = true;
            self.GetAPIUser(function(user){
                self.current_user = user;
                global_data.$emit("user_changed", self.current_user);
                self.loading = false;
                if (check_username) {
                    self.check_username();
                }
            });
        },
        logout: function(){
            var self = this;
            this.API({
                endpoint: 'auth/token/logout',
                funcThen: function(response){
                    self.LogoutUser();
                    self.get_user();
                    window.location.href = "/";
                },
                isPost:true
            });

            
        },
        updateUsername: function(){
            var self = this;
            var patchData = {
                username: self.patchUsername
            }
            this.API({
                endpoint: 'auth/users/me',
                funcThen: function(response){
                    self.current_user = response.data;
                    $('.modal-container-needs-username').removeClass('modal-active');
                },
                funcCatch: function(error){
                    self.patch_username_error_results = error.response.data;
                },
                isPatch:true,
                postData: patchData
            });
        },
        register: function(){
            var self = this;
            this.API({
                endpoint: 'auth/users',
                funcThen: function(response){
                    self.account_created = true;
                },
                funcCatch: function(error){
                    self.register_error_results = error.response.data;
                },
                isPost:true,
                postData: { 
                    username: self.registerUsername,
                    first_name: self.registerFirstName,
                    last_name: self.registerLastName,
                    email: self.registerEmail,
                    password: self.registerPassword,
                    re_password: self.registerConfirmPassword,
                    profile: {
                        include_in_directory: self.registerDirectoryInclude
                    }
                }
            });
        }
    },
    computed:{
        logged_in:{
            get: function(){
                return this.current_user != null;
            }
        },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/mini-apps/Login.vue